/**
 * R3F component that initializes the particle manager singleton.
 * Must be rendered inside Canvas. Calls init on mount, update in useFrame, dispose on unmount.
 */

import { useEffect } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import { particleManager } from './ParticleManager.js';

export function ParticleManagerInit() {
  const scene = useThree((state) => state.scene);

  useEffect(() => {
    particleManager.init(scene);
    return () => {
      particleManager.dispose();
    };
  }, [scene]);

  useFrame((_, delta) => {
    particleManager.update(delta);
  });

  return null;
}
